"use client";

/**
 * The maintenance lock a Kuttos admin switches on (lib/config/maintenance.ts):
 * the outage screen itself, covering everything on the brand's address. It
 * does not reload itself — MaintenanceGate lifts it the moment the switch
 * goes off.
 */

import { StatusScreen } from "./StatusScreen";

export function MaintenanceScreen({ note, subdomain }: { note?: string | null; subdomain?: string | null }) {
  return (
    <div
      role="alert"
      aria-live="polite"
      style={{ position: "fixed", inset: 0, zIndex: 2147483647, overflowY: "auto", background: "#120812" }}
    >
      <StatusScreen code="service_down" sub={subdomain} note={note} reloadOnRetry={false} />
    </div>
  );
}

export default MaintenanceScreen;
